module.exports = __webpack_public_path__ + "img/index_1.1d9f719b.jpg";